import { createFileRoute } from "@tanstack/react-router";
import CountryListings from "@/pages/CountryListings";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/vehicles/")({
  head: () => routeHead("/de/vehicles/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CountryListings />
  );
}
